import {Routes} from '@angular/router';

export const freeShippingCashRoutes: Routes = [
  {
    path: 'freeShipping.cash',
    loadComponent: () => import('./freeshipping.cash.component').then(m => m.FreeshippingCashComponent),
    data: {title: '今日免单兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.lottery.cash',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '今日免单抽奖兑付明细' },
      },
      {
        path: 'add.lottery.cash/:orderId',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '今日免单抽奖兑付明细' },
      }
    ]
  },
]
